export class QueryBuilder {
    constructor() {
      this.options = {
        filters: [],
      };
    }
  
    where(field, operatorOrValue, valueIfOperator) {
      let operator = 'eq';
      let value = operatorOrValue;
  
      if (valueIfOperator !== undefined) {
        operator = operatorOrValue;
        value = valueIfOperator;
      }
  
      this.options.filters.push({ field, operator, value });
      return this;
    }

    or(...queries) {
      const conditions = queries.flatMap(q => q._build().filters);
      this.options.filters.push({ type: 'or', conditions });
      return this;
    }
  
    and(...queries) {
      const conditions = queries.flatMap(q => q._build().filters);
      this.options.filters.push({ type: 'and', conditions });
      return this;
    }
  
    notEq(field, value) { return this.where(field, 'notEq', value); }
    gt(field, value) { return this.where(field, 'gt', value); }
    gte(field, value) { return this.where(field, 'gte', value); }
    lt(field, value) { return this.where(field, 'lt', value); }
    lte(field, value) { return this.where(field, 'lte', value); }
    like(field, value) { return this.where(field, 'like', value); }
    oneOf(field, value) { return this.where(field, 'oneOf', value); }
    notIn(field, value) { return this.where(field, 'notIn', value); }
    between(field, value) { return this.where(field, 'between', value); }
  
    sortBy(field, order = 'asc') {
      this.options.sortBy = field;
      this.options.sortOrder = order;
      return this;
    }
  
    skip(count) {
      this.options.skip = count;
      return this;
    }
  
    take(count) {
      this.options.take = count;
      return this;
    }
  
    _build() {
      return this.options;
    }
}
  
export const Q = {
    where: (...args) => new QueryBuilder().where(...args),
    or: (...args) => new QueryBuilder().or(...args),
    and: (...args) => new QueryBuilder().and(...args),
    sortBy: (...args) => new QueryBuilder().sortBy(...args),
    skip: (...args) => new QueryBuilder().skip(...args),
    take: (...args) => new QueryBuilder().take(...args),
    notEq: (...args) => new QueryBuilder().notEq(...args),
    gt: (...args) => new QueryBuilder().gt(...args),
    gte: (...args) => new QueryBuilder().gte(...args),
    lt: (...args) => new QueryBuilder().lt(...args),
    lte: (...args) => new QueryBuilder().lte(...args),
    like: (...args) => new QueryBuilder().like(...args),
    oneOf: (...args) => new QueryBuilder().oneOf(...args),
    notIn: (...args) => new QueryBuilder().notIn(...args),
    between: (...args) => new QueryBuilder().between(...args),
};